import './OrgLogoNameWidget.css';

import React from 'react';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import useGetOrganizationInfo from '../../../../b2b-users/hooks/useGetOrganizationInfo';
import { Avatar } from '@mui/material';
import { fullImagePath } from '../../../../b2b-common/helpers';

const OrgLogoNameWidget = ({ widget }) => { 

    const { t } = useB2BTranslation('b2b-reporting');
    const { organizationName, organizationImage } = useGetOrganizationInfo();

    const { title } = widget.widgetConfig || null;

    return (
        <div className='OrgLogoNameWidget-container'>
            <Avatar alt={organizationName} src={fullImagePath(organizationImage)}
                className='OrgLogoNameWidget-image'
            />
            <div className='OrgLogoNameWidget-name'>
                <p>{title || t('Organization')}</p>
                <h1>{organizationName}</h1>
            </div>
        </div>
    );
}

export default OrgLogoNameWidget;